let memoizedColumns = []
const ShiftTypeColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'shift_name',
            header: 'Shift Name',
        },
        {
            accessorKey: 'start_time',
            header: 'Start Time',
        },
        {
            accessorKey: 'end_time',
            header: 'End Time',
        },
    ]
    return memoizedColumns
}
export default ShiftTypeColumn
